import { useEffect, useState } from 'react';
import axios from 'axios';

function VerifyEmail() {
	const BASE_URL =
		window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

	const [status, setStatus] = useState('Verifying your email...');

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const token = params.get('token');

		if (!token) {
			setStatus('Invalid verification link.');
			return;
		}

		axios
			.get(`${BASE_URL}/api/auth/verify-email?token=${encodeURIComponent(token)}`)
			.then((res) => {
				if (res.data.success) {
					setStatus(res.data.message || 'Email verified successfully!');
					window.location.href = '/login';
				} else {
					setStatus(res.data.message || 'Verification failed.');
					window.close();
				}
			})
			.catch(() => {
				setStatus('Verification failed.');
			});
	}, []);

	return (
		<div
			style={{
				textAlign: 'center',
				marginTop: '50px',
				fontSize: '1.2rem',
			}}>
			{status}
		</div>
	);
}

export default VerifyEmail;
